import React from "react";
import Dialog from "@mui/material/Dialog";
import { DialogContent, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { handleAddClose } from "../../redux/Reducer/ModalSlice";

function AddModal({ children, ModalWidth, ModalTitle }) {
  const add = useSelector((state) => state.Modal.add);
  const dispatch = useDispatch();
 
  return (
    <Dialog
      open={add}
      fullWidth={true}
      maxWidth={ModalWidth}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            color: "#4187e8",
          }}
        >
          {ModalTitle}
        </span>
        <CloseIcon
          sx={{ mt: "5px", cursor: "pointer" }}
          onClick={() => {
            dispatch(handleAddClose());
          }}
        />
      </DialogTitle>
      <DialogContent dividers style={{ padding: " 0px" }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default AddModal;
